import React, { useState, useEffect } from 'react';
import { Modal, Button } from 'antd';
import SegmentConditionBuilder from './SegmentConditionBuilder';
import SegmentSummary from './SegmentSummary';
import { useAttributeOptions } from '../data/touchpointHooks';
import { useSegmentMatchCount } from '../data/journeyHooks';
import { collectConditions } from './conditionModel';
import { buildSummary } from './segmentHumanize';
import { buildProductById } from './segmentRead';

export default function SegmentEditorModal({ open, draft, productOptions = [], attributeById = () => null, onDone, onCancel }) {
  const { data: attrOptions = [] } = useAttributeOptions();
  const [work, setWork] = useState(draft);
  useEffect(() => { if (open) setWork(draft); }, [open, draft]);
  const { condition } = collectConditions(work.groups, work.conditionOperator);
  const match = useSegmentMatchCount(condition);
  const summaryModel = buildSummary(work.groups, work.conditionOperator, {
    attributeById,
    productById: buildProductById(productOptions),
  });

  return (
    <Modal title="Edit segmentation" visible={open} width={820} onCancel={onCancel}
      footer={[
        <Button key="cancel" onClick={onCancel}>Cancel</Button>,
        <Button key="done" type="primary" onClick={() => onDone(work)}>Done</Button>,
      ]}>
      <SegmentConditionBuilder draft={work} onChange={setWork} attrOptions={attrOptions} productOptions={productOptions} />
      <div className="seg-preview">
        <div className="seg-preview-cap">Summary</div>
        <div className="seg-preview-card">
          <SegmentSummary model={summaryModel} />
          <div className="seg-preview-count">
            {match.status === 'unavailable' ? 'Match preview unavailable' : `≈ ${match.count} contacts match`}
          </div>
        </div>
      </div>
    </Modal>
  );
}
